import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, SubCard, SubCardContainer, SubCardTitle, SessionsContainer, RightAlignedButton } from "../../common_components/Layout";
import { SessionStat } from "../../common_components/Analytics";
import { PrimaryButton } from "../../common_components/Buttons";
import { SessionHighlightCompleted } from "../../common_components/SessionHighlights";
import DateFormatting from "../../common_components/DateFormatting";


// Api Calls
import ScheduledEventAPI from "../../../api/api_calls/ScheduledEventAPI";


function CompletedSessionsCard(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [loadingEvents, setLoadingEvents] = useState(true);
    const [completedEvents, setCompletedEvents] = useState([]);
    const [scheduledEventsCount, setScheduledEventsCount] = useState(-1);
    const [completedEventsCount, setCompletedEventsCount] = useState(-1);
    const [goalCount, setGoalCount] = useState(-1);
    const [timezone, setTimezone] = useState("");
    const [screenerPassRate, setScreenerPassRate] = useState(null);
    const [totalScreenerResponses, setTotalScreenerResponses] = useState(null);
    const [passingScreenerResponses, setPassingScreenerResponses] = useState(null);



    const mockedCompletedSessions = [
        {
            date: "Wednesday, Sept 2nd",
            time: "4:30 PM",
            name: "Karen",
            id: 1
        },
        {
            date: "Monday, Aug 31st",
            time: "11:30 AM",
            name: "Jack",
            id: 2
        },
        {
            date: "Friday, Aug 28th",
            time: "4:30 PM",
            name: "Ani",
            id: 3
        },

    ]

    useEffect(() => {
        async function getCompletedSessionsAndStats() {
            const result = await ScheduledEventAPI.one_mission_completed_events_and_stats(missionId, navigate);

            if (result.success) {
                setCompletedEvents(result.completed_events)
                setScheduledEventsCount(result.scheduled_events_count)
                setCompletedEventsCount(result.completed_events_count)
                setGoalCount(result.goal_count)
                setTimezone(result.timezone)
                setScreenerPassRate(result.screener_pass_rate)
                setTotalScreenerResponses(result.total_screener_responses)
                setPassingScreenerResponses(result.passing_screener_responses)

                setLoadingEvents(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getCompletedSessionsAndStats();
    }, []);

    const noEventsPlaceholder = (<div className="no-events-placeholder"> No completed sessions yet </div>)

    const completedEventsList = (completedEvents.map((session) => {
        return (
            <SessionHighlightCompleted session={session} timezone={timezone} key={"session-" + session.id} onClick={() => navigate("/missions/" + missionId + "/sessions/" + session.id)} />
        )
    }))

    const completedEventsSwitch = (completedEventsCount > 0 ? completedEventsList : noEventsPlaceholder)

    return (
        <Card>
            <GrayCardTitle title="Completed Sessions" />
            <SubCardContainer>
                <SubCard loading={loadingEvents}>
                    <SubCardTitle>
                        Recent Sessions
                    </SubCardTitle>
                    <SessionsContainer>
                        {completedEventsSwitch}
                    </SessionsContainer>
                    <RightAlignedButton>
                        <PrimaryButton onClick={() => navigate("/missions/" + missionId + "/sessions")} text="View all" submitLoading={props.submitLoading} />
                    </RightAlignedButton>
                </SubCard>
                <SubCard loading={loadingEvents}>
                    <SubCardTitle>
                        Session Stats
                    </SubCardTitle>
                    <div className="session-stats-container">
                        <SessionStat title="Completions" primaryFill={completedEventsCount} goalValue={goalCount} legendText={completedEventsCount + " of " + goalCount} />
                        <SessionStat title="Scheduled" secondaryFill={scheduledEventsCount} goalValue={goalCount} legendText={(scheduledEventsCount) + " of " + goalCount} />
                        {screenerPassRate &&
                            <SessionStat title="Screener Pass Rate" secondaryFill={passingScreenerResponses} goalValue={totalScreenerResponses} legendText={Math.round(screenerPassRate * 100) + "% (" + passingScreenerResponses + " of " + totalScreenerResponses + ")"} />
                        }

                    </div>
                    <div>
                    </div>

                </SubCard>
            </SubCardContainer>
        </Card>

    )
}



export default CompletedSessionsCard;